export const convertToString = (value?: number, { skipZero = true } = {}): string => {
    if (skipZero && value === 0) {
        return '';
    }
    if (typeof value === 'number' && !isNaN(value)) {
        return value.toFixed(2);
    }
    return '';
};
